export { d as deepMerge, p as pick } from '../../dist/pick-eb956227.esm.js';
export { b as b64Decode, a as b64Encode, c as b64UrlDecode, d as b64UrlEncode } from '../../dist/string-5ceb7c80.esm.js';
export { e as equal, k as isArray, h as isBoolean, j as isFunction, c as isNil, i as isNull, f as isNumber, d as isObject, g as isString, b as isUndefined, l as isWindow, n as noop, a as notEqual } from '../../dist/types-97851b96.esm.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.set.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import '../../dist/objectSpread2-04e3d2b4.esm.js';
import '../../dist/defineProperty-6a97efcd.esm.js';
import '../../dist/typeof-5c86a240.esm.js';
import 'core-js/modules/es.object.get-prototype-of.js';
import 'core-js/modules/es.array.reduce.js';
import 'core-js/modules/web.dom-collections.for-each.js';
import 'core-js/modules/es.object.keys.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.array.from.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.regexp.to-string.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.number.constructor.js';

var cache = new Set();
function warn(message, id) {
  if (!cache.has(id !== null && id !== void 0 ? id : message)) {
    console.warn(message);
    cache.add(message);
  }
}

export { warn };
